import { createRouter, createWebHistory } from "vue-router";
import TheHomepage from "./pages/TheHomepage.vue";
import AboutPage from "./pages/AboutPage.vue";
import ResumePage from "./pages/ResumePage.vue";
import ProjectPage from "./pages/ProjectPage.vue";
import NotFound from "./pages/NotFoundPage.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", redirect: "/home" },
    { path: "/home", component: TheHomepage },
    { path: "/about", component: AboutPage },
    { path: "/resume", component: ResumePage },
    { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound },
    { path: "/project_:workID", component: ProjectPage, props: true },
  ],
  linkActiveClass: "active",
});

export default router;
